module.exports = __webpack_public_path__ + "img/icon_mail.127e262.svg";